<template>
  <div class="steps-content">
    <el-form ref="form" :model="extra_fields" @submit.native.prevent>
      <el-row :gutter="24">
        <el-col v-for="f in fields.types" :key="f.id" :xs="24" :sm="12">
          <el-form-item
            :prop="f.id"
            :label="f.label ? f.label : 'Кастомное поле'"
            :rules="{
              required: false,
              message: 'Заполните это поле',
              trigger: 'blur',
            }"
          >
            <el-input
              v-model="extra_fields[f.id]"
              placeholder="Введите текст"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="bottom_buttons">
      <el-button @click="setFormData(-1)">Назад</el-button>
      <el-button @click="setFormData(1)">Далее</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomFields',
  props: {
    saved: {
      type: Object,
      default: () => undefined,
    },
    fields: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      extra_fields: {},
    }
  },
  watch: {
    fields: {
      immediate: true,
      handler(newVal) {
        this.extra_fields = { ...newVal.extra_fields }
      },
    },
  },
  methods: {
    setFormData(step) {
      const extra_fields = {}

      for (let k in this.extra_fields) {
        if (!Object.prototype.hasOwnProperty.call(this.extra_fields, k)) {
          continue
        }
        extra_fields[k] = {
          field_id: k,
          value: this.extra_fields[k],
        }
      }
      const data = { extra_fields }

      if (step === -1) {
        this.$emit('change_step', { data, step })
      } else {
        this.$refs['form'].validate(valid => {
          if (valid) {
            this.$emit('change_step', { data, step })
          } else {
            this.$emit('invalid')
          }
        })
      }
    },
  },
}
</script>
